import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

function usePostcodes(subDistrictId) {
  const [postcodes, setPostcodes] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const p = await dataProvider.getList("postcodes", {
          filter: { sub_district_id: subDistrictId },
        });
        setPostcodes(p.data);
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subDistrictId]);

  return {
    postcodes,
    loading,
    error,
  };
}

export default usePostcodes;
